import * as React from 'react';
// import { styled } from '@mui/material/styles';
// import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
// import { useState } from 'react';
import '../styles/TutorSearchPage.css';
import Select from "react-select";
// import { right } from '@popperjs/core';



const options = [
    { label: "Grapes 🍇", value: "grapes" },
    { label: "Mango 🥭", value: "mango" },
    { label: "Strawberry 🍓", value: "strawberry" },
    { label: "Watermelon 🍉", value: "watermelon" },
    { label: "Pear 🍐", value: "pear", disabled: true },
    { label: "Apple 🍎", value: "apple" },
    { label: "Tangerine 🍊", value: "tangerine" },
    { label: "Pineapple 🍍", value: "pineapple" },
    { label: "Peach 🍑", value: "peach" }
  ];

const days = [
    { label: "Monday ", value: "monday" },
    { label: "Tuesday", value: "tuesday" },
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" }
  ];

const time = [
    { label: "Morning", value: "morning" },
    { label: "Afternoon", value: "afternoon" },
    { label: "Evening", value: "evening" }
]

const lessonType = [
    { label: "Home", value: "home" },
    { label: "Tuition Center", value: "tuition_center" }
]


  // const customValueRenderer = (selected, _options) => {
  //   return selected.length
  //     ? selected.map(({ label }) => "✔️ " + label)
  //     : "😶 No Items Selected";
  // };


  // const defaults = [colourOptions[1], colourOptions[2]];
  // const defaults = [option., colourOptions[2]];


export function TutorSearchFilterOptions() {
  // const [selected, setSelected] = useState([]);

  const customStyles = {
  
    dropdownIndicator: base => ({
      ...base,
      color: '#EC6607',
      hover: {
        backgroundColor: "#EC6607",
      }
    }),
    clearIndicator: base => ({
      ...base,
      color: '#EC6607',
      hover: {
        backgroundColor: "#EC6607",
      }
    }),

    control: (base, state) => ({
      ...base,
      color: "#EC6607",
      borderWidth: 1,
      borderColor: state.isFocused ? "#EC6607" : "#EC6607",
      boxShadow: state.isFocused ? "#EC6607" : "#EC6607", 
      "&:hover": {
        borderColor: "#EC6607",
      },
    }),

    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar" :{
        width: "4px",
      
    },
     
    "::-webkit-scrollbar-track": {
        // box-shadow: "inset 0 0 6px rgba(0,0,0,0.3) "
        borderRadius: "10px",
        // padding: "10px"
    },
     
    "::-webkit-scrollbar-thumb" :{
        borderRadius: "10px",
        // -webkit-box-shadow: "inset 0 0 6px rgba(0,0,0,0.5)"
        background: "#EC6607"
    }

    }),
  };


  return (
   
        <>
        
        <Grid container spacing={2} px={2} pb={1}>
          <Grid item xs={6} className='grid content-start'>
              <Typography variant="h7" align="left" fontSize={28} fontWeight={400} fontFamily={"Faustina"} color={"black"}>
                  Filters
              </Typography>
          </Grid>
          <Grid item xs={6} className='grid content-end'>
              <Typography variant="h7" align="right" fontSize={28} fontWeight={400} fontFamily={"Faustina"} color={"black"}>
                  Found total of 50 results
              </Typography>
          </Grid>
        </Grid>
    
      <Grid container spacing={2} px={2} pb={3} width={'100%'}  flex-direction="row"  justifyContent="space-between"  >
      
    
    
              <Grid item >
                <Select
                  styles={customStyles}
                      closeMenuOnSelect={false}
                      maxMenuHeight={157}
                      menuShouldScrollIntoView={true}
                      placeholder="Select a Category"
                      components={{
                        IndicatorSeparator: () => null,
                        scrollBarColor: "#EC6607",
                      }}
                      options={options}
                />
              </Grid>
              <Grid item >
                <Select
                  styles={customStyles}
                      closeMenuOnSelect={false}
                      maxMenuHeight={157}
                      menuShouldScrollIntoView={true}
                      placeholder="Select Day(s)"
                      isMulti
                      components={{
                        IndicatorSeparator: () => null,
                        scrollBarColor: "#EC6607",
                      }}
                      options={days}
                />
              </Grid>
              <Grid item >
                <Select
                  styles={customStyles}
                      closeMenuOnSelect={false}
                      maxMenuHeight={157}
                      menuShouldScrollIntoView={true}
                      placeholder="Select Time"
                      isMulti
                      components={{
                        IndicatorSeparator: () => null,
                        scrollBarColor: "#EC6607",
                      }}
                      options={time}
                />
              </Grid>
              <Grid item >
                <Select
                  styles={customStyles}
                      closeMenuOnSelect={false}
                      maxMenuHeight={157}
                      menuShouldScrollIntoView={true}
                      placeholder="Select lesson type"
                      isMulti
                      components={{
                        IndicatorSeparator: () => null,
                        scrollBarColor: "#EC6607",
                      }}
                      options={lessonType}
                />
              </Grid>
              <Grid item >
                <Select
                  styles={customStyles}
                      closeMenuOnSelect={false}
                      maxMenuHeight={157}
                      menuShouldScrollIntoView={true}
                      placeholder="Select price range"
                      isMulti
                      components={{
                        IndicatorSeparator: () => null,
                        scrollBarColor: "#EC6607",
                      }}
                      options={options}
                />
              </Grid>
              <Grid item >
                <Select
                  styles={customStyles}
                      closeMenuOnSelect={false}
                      maxMenuHeight={157}
                      menuShouldScrollIntoView={true}
                      placeholder="Select a ratings"
                      isMulti
                      components={{
                        IndicatorSeparator: () => null,
                        scrollBarColor: "#EC6607",
                      }}
                      options={options}
                />
              </Grid>
              <Grid item >
                <Select
                  styles={customStyles}
                      closeMenuOnSelect={false}
                      maxMenuHeight={157}
                      menuShouldScrollIntoView={true}
                      placeholder="Select a sortby"
                      components={{
                        IndicatorSeparator: () => null,
                        scrollBarColor: "#EC6607",
                      }}
                      options={options}
                />
              </Grid>
    
    </Grid>
     
          </>

  );
}

